import { createDocumentWorkflowService } from '@heyjob-dash/shared/company/documents/workflow-service';

import apiClient from './ApiService';

export default createDocumentWorkflowService(apiClient);
